import { GuestGuard } from "app/features/authentication/guards/GuestGuard";
import AccountResetScreen from "app/screens/authentication/AccountResetScreen";

export default function AccountResetPage() {
  return <GuestGuard>
    <AccountResetScreen />
  </GuestGuard>;
}
